import { API } from "aws-amplify";

export default new (class {
  async fetchTempVideoURLsByID(submissionID) {
    console.log('VIDEO SEQUENCE: get video by url')
    const result = await API.get('sfTherapistSubmission', '/therapist/submissions/' + submissionID);
    console.log('VIDEO SEQUENCE: fetch video urls: ', result)
    return result;
  }
})();